export default __webpack_public_path__ + "static/media/Ring of Scalding.5c0824a5.jpg";